import React, { useState } from 'react';
import Box from "@mui/material/Box";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

// date time
import dayjs, { Dayjs } from 'dayjs';
import {DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { useSelector } from 'react-redux';
import {
  selectLogged,
  selectLastSessionChecked,
  LoggedData,
  Session,
} from './sessionSlice';
import styles from './Session.module.css';

function SessionInfo(props: {session: Session}) {
	const [value, setValue] = useState<Dayjs | null>(dayjs(props.session.exp_time));
	const log = dayjs(props.session.log_time).format('L LT')
	const exp = dayjs(props.session.exp_time).format('L LT')
	return (
		<Card className={styles.row}>
			<CardContent>
				<Typography variant="h2">
					User Session
				</Typography>
				<Typography variant="body2">
					<span color="text.body2">log</span>: { log } <br />
					<span color="text.body2">exp</span>: { exp }
				</Typography>
				<Typography variant="body2">
					user.id: {props.session.user.id} <br />
				</Typography>
				<Typography variant="body2">
					user.name: {props.session.user.name} <br />
				</Typography>
				<DateTimePicker value={value} />
			</CardContent>
		</Card>
	);
}

export function SessionDebug() {
	const session = useAppSelector(selectLogged);
  const lsc = useAppSelector(selectLastSessionChecked);
  const dispatch = useAppDispatch();
  const [incrementAmount, setIncrementAmount] = useState('4');

  const incrementValue = Number(incrementAmount) || 0;
  const sess = (session)
  ? <SessionInfo session={session} /> : <div> no session</div>;

  return (
    <div>
      <div className={styles.row}>
		  <Typography variant="h1">
			  Debugging Users Feature ...
		  </Typography>
      </div>
      <div className={styles.row}>
		{ sess }
      </div>
      <div className={styles.row}>
		  <Card>
			  <CardContent>
				  <Typography>
					  {dayjs(lsc).format('DD-MM-YYYY HH:mm:ss')}
				  </Typography>
			  </CardContent>
		  </Card>
      </div>
    </div>
  );
}
